import { ungzip } from 'pako';
import { formatBytes } from './utils.mjs';

export class Library {
	constructor() {
		this.cacheParentElem = null;
		this.cacheTextElem = null;
		this.pathFiles = './data/songs/';
		this.pathLibrary = './data/library/';
		this.libraryNames = [
			'classic', 'js-256', 'js-1k', 'js-big', 'floatbeat', 'floatbeat-big',
			'funcbeat', 'zopium', 'zopium-cloud', 'greggman', 'dense', 'recent', 'remixes', 'all'
		];
		this.showAllSongs = false;
		this.songs = null;
		this.loadingLibraries = new Map();
		this.searchQuery = '';
		this.searchLoading = false;
		this.autoUpdate = true;

		// Check for admin login
		const cookie = {};
		document.cookie.split(';').forEach(el => {
			const split = el.split('=');
			cookie[split[0].trim()] = split.slice(1).join('=');
		});
		this.isAdmin = cookie.bytebeat_access;
	}
	setAutoUpdate(enabled) {
		this.autoUpdate = enabled !== false;
	}
	getLibraryUrl(libName) {
		const url = this.pathLibrary + libName + '.gz';
		return this.autoUpdate ? `${ url }?library-update=${ Date.now() }` : url;
	}
	fetchLibrary(libName) {
		return fetch(this.getLibraryUrl(libName), this.autoUpdate ? { cache: 'no-store' } : undefined);
	}
	cacheSongs(libArr) {
		this.songs = new Map();
		for(let i = 0, iLen = libArr.length; i < iLen; ++i) {
			const { author } = libArr[i];
			for(let j = 0, jLen = libArr[i].songs.length; j < jLen; ++j) {
				const song = libArr[i].songs[j];
				song.author = author;
				this.songs.set(song.hash, song);
			}
		}
	}
	escapeHTML(text) {
		this.cacheTextElem.nodeValue = text;
		return this.cacheParentElem.innerHTML;
	}
	generateEntryHTML({
		author, code, codeFormLen, codeLen, codeMin, codeMinLen, coverName, coverUrl, date, description,
		drawing, fileForm, fileMin, fileOrig, hash, mode, name, remix, sampleRate, songs, stereo, tags, url
	}, libName) {
		const notAllLib = libName !== 'all' && libName !== 'recent';
		if(songs) {
			let songsStr = '';
			const len = songs.length;
			const maxVisible = 10;
			const needToHide = len - maxVisible;
			if(notAllLib && len > maxVisible + 3) {
				songsStr += `<details><summary class="code-button songs-toggle">${
					needToHide } more bytebeats</summary>`;
				for(let i = 0; i < len; ++i) {
					if(i === needToHide) {
						songsStr += '</details>';
					}
					songsStr += this.generateEntryHTML(songs[i], libName);
				}
			} else {
				for(let i = 0; i < len; ++i) {
					songsStr += this.generateEntryHTML(songs[i], libName);
				}
			}
			return `<details class="songs-block"${
				notAllLib || this.showAllSongs ? ' open' : ''
			}><summary class="songs-header"> <b>${ author }</b>${
				author === 'SthephanShi' ? '<small style="color: #ff0;">dollchan creator</small>' : '' }${
				len ? `<small> ${ len } song${ len > 1 ? 's' : '' }</small>` : ''
			}</summary><div class="songs">${ songsStr }</div></details>`;
		}
		let str = '<div class="song-heading">';
		const noArrayUrl = url && !Array.isArray(url);
		if(name) {
			str += url ? `<a href="${ noArrayUrl ? url : url[0] }" target="_blank">${ name }</a>` : name;
		}
		if(author) {
			str += ` <span>by ${ name || !noArrayUrl ? `<b>${ author }</b>` :
				`<a href="${ url }" target="_blank">${ author }</a>` }</span>`;
		}
		const songObj = { sampleRate, mode };
		if(url && (!noArrayUrl || !name && !author)) {
			if(noArrayUrl) {
				str += `[<a href="${ url }" target="_blank">link</a>]`;
			} else {
				const urlsArr = [];
				for(let i = name ? 1 : 0, len = url.length; i < len; ++i) {
					urlsArr.push(`<a href="${ url[i] }" target="_blank">link${ i + 1 }</a>`);
				}
				str += ` [${ urlsArr.join(', ') }]`;
			}
		}
		str += ' <span class="code-info">';
		if(date) {
			str += date;
		}
		if(mode) {
			str += ' ' + mode;
		}
		str += ` ${ sampleRate }Hz`;
		const tagsArr = [];
		if(stereo) {
			tagsArr.push('<span class="tag-stereo">stereo</span>');
		}
		if(drawing) {
			songObj.drawMode = drawing.mode;
			songObj.scale = drawing.scale;
			tagsArr.push('<span class="tag-drawing">drawing</span>');
		}
		for(let i = 0, len = tags.length; i < len; ++i) {
			switch(tags[i]) {
			case '1k':
			case '256':
			case 'big': continue;
			case 'c':
				if(!notAllLib) {
					tagsArr.push('<span class="tag-c">c</span>');
				}
				continue;
			case 'console':
				tagsArr.push('<span class="tag-console">console</span>');
				continue;
			case 'sample':
				tagsArr.push('<span class="tag-sample">sample</span>');
				continue;
			case 'slow':
				tagsArr.push('<span class="tag-slow">slow</span>');
				continue;
			}
			tagsArr.push(`<span class="tag-custom">${ tags[i] }</span>`);

		}
		if(tagsArr.length) {
			str += ` <span class="code-tags">${ tagsArr.join('') }</span>`;
		}
		str += '</span>';
		if(this.isAdmin) {
			str += ` <a href="bytebeat.php?editsong_request&hash=${ hash }" target="_blank">Edit</a> / ` +
				`<a class="song-hash" href="#" data-hash="${ hash }">Hash</a>`;
		}
		str += '</div>';
		if(description) {
			str += `<div class="code-description">${ description }</div>`;
		}
		if(remix) {
			for(let i = 0, len = remix.length; i < len; ++i) {
				const { hash: rHash, url: rUrl, name: rName, author: rAuthor } = remix[i];
				str += '<div class="code-remix"><div class="code-remix-preview"> remix of ' +
					`<button class="code-button code-remix-load" data-hash="${
						rHash }" title="Show detailed source information">&gt;</button> <span>${
						rUrl ? `<a href="${
							rUrl.startsWith('[') ? rUrl.match(/"([^"]+)"/)[1] : rUrl }" target="_blank">${
							rName || rAuthor }</a>` :
						`"${ rName }"` }${ rName && rAuthor ? ' by ' + rAuthor : '' }</span></div></div>`;
			}
		}
		if(coverName) {
			str += `<div class="code-cover">cover of ${ coverUrl ?
				`<a href="${ coverUrl }" target="_blank">${ coverName }</a>` : `"${ coverName }"` }</div>`;
		}
		const sData = ` data-songdata='${ JSON.stringify(songObj) }'`;
		str += '<div class="code-buttons">';
		if(codeMin || fileMin) {
			str += `<button class="code-button code-load code-play" data-type="minified" aria-label="Play minified code" title="Play minified code"${ sData }${
				fileMin ? ` data-code-file="${ hash }.js"` : '' }>Play <small>min ${ formatBytes(codeMinLen) }</small></button>`;
		}
		if(code || fileOrig) {
			str += `<button class="code-button code-load" data-type="original" aria-label="Play original code" title="Play original code"${ sData }${
				fileOrig ? ` data-code-file="${ hash }.js"` : '' }>orig <small>${ formatBytes(codeLen) }</small></button>`;
		}
		if(fileForm) {
			str += `<button class="code-button code-load" data-type="formatted" aria-label="Play formatted code" title="Play formatted code"${ sData } data-code-file="${
				hash }.js">format <small>${ formatBytes(codeFormLen) }</small></button>`;
		}
		str += '</div>';
		if(codeMin) {
			str += `<button class="code-text code-text-min"${ sData }>${ this.escapeHTML(codeMin) }</button>`;
		}
		if(code) {
			str += `<button class="code-text code-text-orig${ codeMin ? ' hidden' : '' }"${
				sData }>${ this.escapeHTML(code) }</button>`;
		}
		return `<div class="entry library-song-entry" data-library="${ libName }">${ str }</div>`;
	}
	initElements() {
		this.cacheParentElem = document.createElement('div');
		this.cacheParentElem.appendChild(this.cacheTextElem = document.createTextNode(''));
	}
	async onclickCodeLoadButton(buttonElem) {
		if(buttonElem.dataset.codeFile) {
			buttonElem.insertAdjacentHTML('beforeend',
				'<svg class="loading-wait"><use xlink:href="#symbol-wait"></use></svg>');
			const waitElem = buttonElem.lastChild;
			const response = await fetch(this.pathFiles + buttonElem.dataset.type +
				'/' + buttonElem.dataset.codeFile);
			globalThis.bytebeat.loadCode(Object.assign(JSON.parse(buttonElem.dataset.songdata),
				{ code: await response.text() }));
			waitElem.remove();
		} else {
			const codeTextElem = buttonElem.parentNode.parentNode
				.querySelector(buttonElem.dataset.type === 'minified' ?
					':scope > .code-text-min' : ':scope > .code-text-orig');
			globalThis.bytebeat.loadCode(Object.assign(JSON.parse(buttonElem.dataset.songdata),
				{ code: codeTextElem.innerText }));
		}
	}
	async onclickLibraryHeader(headerElem) {
		const containerElem = headerElem.nextElementSibling;
		if(containerElem.classList.contains('loaded') || headerElem.parentNode.open) {
			return;
		}
		const libName = containerElem.id.replace('library-', '');
		await this.loadLibrary(libName);
	}
	async loadLibrary(libName) {
		const containerElem = document.getElementById('library-' + libName);
		if(!containerElem || containerElem.classList.contains('loaded')) {
			return;
		}
		containerElem.classList.add('song-library-container');
		if(this.loadingLibraries.has(libName)) {
			return this.loadingLibraries.get(libName);
		}
		const headerElem = containerElem.previousElementSibling;
		const waitElem = headerElem && headerElem.querySelector('.loading-wait');
		const promise = (async () => {
			containerElem.classList.add('loaded', 'library-loading');
			waitElem?.classList.remove('hidden');
			try {
				const response = await this.fetchLibrary(libName);
				if(response.status !== 200 && response.status !== 304) {
					throw new Error(`${ response.status } ${ response.statusText }`);
				}
				const libArr = JSON.parse(ungzip(await response.arrayBuffer(), { to: 'string' }));
				const songCount = libArr.reduce((total, group) => total + (group.songs?.length || 0), 0);
				const showAllControl = libName === 'all' || libName === 'recent' ?
					`<label class="library-show-all-label"><input type="checkbox" class="library-show-all"${
						this.showAllSongs ? ' checked' : '' }> Show all authors</label>` : '';
				containerElem.innerHTML = `<div class="library-section-toolbar"><span>${ libArr.length } authors</span><strong>${
					songCount } songs</strong><span class="library-visible-count" aria-live="polite"></span>${ showAllControl }</div>`;
				let libHTML = '';
				for(let i = 0, len = libArr.length; i < len; ++i) {
					libHTML += this.generateEntryHTML(libArr[i], libName);
				}
				if(!this.songs && libName === 'all') {
					this.cacheSongs(libArr);
				}
				containerElem.insertAdjacentHTML('beforeend', libHTML);
				this.filter(this.searchQuery, false);
			} catch(err) {
				containerElem.classList.remove('loaded');
				containerElem.innerHTML = `<div class="loading-error">Unable to load the library: ${ err.message }</div>`;
			} finally {
				containerElem.classList.remove('library-loading');
				waitElem?.classList.add('hidden');
			}
		})();
		this.loadingLibraries.set(libName, promise);
		try {
			await promise;
		} finally {
			this.loadingLibraries.delete(libName);
		}
	}
	async loadAllLibraries() {
		const button = document.getElementById('library-load-all');
		if(button) {
			button.disabled = true;
			button.textContent = 'Indexing…';
		}
		try {
			await Promise.all(this.libraryNames.map(libName => this.loadLibrary(libName)));
			this.updateSearchStatus();
		} finally {
			if(button) {
				button.disabled = false;
				button.textContent = 'Index all';
			}
		}
	}
	focusSearch() {
		const searchElem = document.getElementById('library-search');
		if(!searchElem) {
			return;
		}
		document.getElementById('simbeat-search')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		searchElem.focus({ preventScroll: true });
	}
	async jumpToShelf(libName) {
		const containerElem = document.getElementById('library-' + libName);
		const target = libName === 'community' ? document.getElementById('library-community') : containerElem;
		if(!target) {
			return;
		}
		const details = target.closest('details');
		details?.setAttribute('open', '');
		if(libName !== 'community') {
			await this.loadLibrary(libName);
		}
		document.querySelectorAll('.library-shelf-button').forEach(button =>
			button.classList.toggle('is-active', button.dataset.libraryJump === libName));
		target.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
	filter(value = this.searchQuery, announce = true) {
		this.searchQuery = value.trim().toLowerCase();
		for(const containerElem of document.querySelectorAll('.song-library-container')) {
			let visibleInSection = 0;
			for(const entry of containerElem.querySelectorAll('.library-song-entry')) {
				const isVisible = !this.searchQuery || entry.textContent.toLowerCase().includes(this.searchQuery);
				entry.classList.toggle('library-result-hidden', !isVisible);
				if(isVisible) {
					++visibleInSection;
				}
			}
			for(const group of containerElem.querySelectorAll('.songs-block')) {
				const hasMatch = !this.searchQuery || group.querySelector('.library-song-entry:not(.library-result-hidden)');
				group.classList.toggle('library-result-hidden', !hasMatch);
			}
			const countElem = containerElem.querySelector('.library-visible-count');
			if(countElem) {
				countElem.textContent = this.searchQuery ? `${ visibleInSection } shown` : '';
			}
		}
		for(const post of document.querySelectorAll('.community-post')) {
			post.classList.toggle('library-result-hidden', Boolean(this.searchQuery) &&
				!post.textContent.toLowerCase().includes(this.searchQuery));
		}
		this.updateSearchStatus();
		if(announce && this.searchQuery && !this.searchLoading) {
			this.searchLoading = true;
			this.loadAllLibraries().finally(() => {
				this.searchLoading = false;
				this.filter(this.searchQuery, false);
			});
		}
	}
	clearSearch() {
		const searchElem = document.getElementById('library-search');
		if(searchElem) {
			searchElem.value = '';
			this.focusSearch();
		}
		this.filter('');
	}
	updateSearchStatus() {
		const statusElem = document.getElementById('song-library-status');
		if(!statusElem) {
			return;
		}
		const loaded = document.querySelectorAll('.song-library-container.loaded').length;
		const visible = document.querySelectorAll('.library-song-entry:not(.library-result-hidden), .community-post:not(.library-result-hidden)').length;
		if(this.searchQuery) {
			statusElem.textContent = this.searchLoading ? 'Loading every library…' :
				`${ visible } match${ visible === 1 ? '' : 'es' } across ${ loaded } librar${ loaded === 1 ? 'y' : 'ies' }`;
		} else if(loaded) {
			statusElem.textContent = `${ loaded } librar${ loaded === 1 ? 'y' : 'ies' } loaded`;
		} else {
			statusElem.textContent = 'Browse by style, size, or author';
		}
	}
	async onclickRemixLoadButton(elem) {
		const parentElem = elem.parentNode;
		if(parentElem.nextSibling) {
			parentElem.nextSibling.remove();
			elem.nextElementSibling.style.display = 'inline';
			return;
		}
		if(!this.songs) {
			elem.insertAdjacentHTML('beforeend',
				'<svg class="loading-wait"><use xlink:href="#symbol-wait"></use></svg>');
			const response = await this.fetchLibrary('all');
			this.cacheSongs(JSON.parse(ungzip(await response.arrayBuffer(), { to: 'string' })));
			elem.lastChild.remove();
		}
		parentElem.insertAdjacentHTML('afterend',
			this.generateEntryHTML(this.songs.get(elem.dataset.hash), 'all'));
		elem.nextElementSibling.style.display = 'none';
	}
	toggleAll(elem, isChecked) {
		this.showAllSongs = isChecked;
		document.querySelectorAll('.songs-block').forEach(
			node => node.toggleAttribute('open', isChecked));
		document.querySelectorAll('.library-show-all').forEach(
			control => control.checked = isChecked);
	}
}
